import Left from './Elements/Left';
import Right from './Elements/Right';

const Body = () => {
    return <div className='bodyArea'>
        <Left/>
        <Right/>
    </div>
}
export default Body;